import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';
import { SubjectAnpr } from 'shell/models/act-category-list';

export const checkError = (subjectAnpr: SubjectAnpr): string => {
  const isForeign = subjectAnpr.idStatoNascita !== CODE_STATE_ITALIAN;

  if (isForeign && !subjectAnpr.idComuneNascita) {
    return formatErrorMunicipalityForeign(
      subjectAnpr.localitaEsteraNascita,
      subjectAnpr.nomeStatoNascita
    );
  }

  return '';
};

export const formatErrorMunicipalityForeign = (
  localitaEsteraNascita?: string,
  nomeStatoNascita?: string
): string => {
  return `Comune estero ${localitaEsteraNascita ? `${localitaEsteraNascita}` : ''} ${
    nomeStatoNascita ? `(${nomeStatoNascita})` : ''
  } non presente: inserire il comune prima di effettuare la registrazione in archivio`;
};
